import { getMomentTz } from "@dexteel/mesf-core";
import {
  Box,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  useTheme,
} from "@mui/material";
import { HeatData } from "../models/HeatReportModels";
import {
  LeftGroupedTextField,
  RightGroupedTextField,
} from "../styles/HeatReportStyledComponents";
import { getHeatStatus } from "../utils/getHeatStatus";
import { HeatNavigatorWithSearch } from "./controls/HeatNavigatorWithSearch";
interface Props {
  heat: HeatData;
  getDataFromAPI: (heatId: number | null) => void;
}
const moment = getMomentTz();
export const HeaderHeatDataReport = ({ heat, getDataFromAPI }: Props) => {
  const theme = useTheme();
  return (
    <Paper elevation={0}>
      <Box padding={1}>
        <Grid item xs={12} container spacing={2}>
          {/* Column 1*/}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            container
            spacing={1}
            key="col-heat-number"
          >
            <Grid item xs={12} key="heat-number" alignContent="center">
              <HeatNavigatorWithSearch
                value={heat}
                onChange={(heatId) => {
                  getDataFromAPI(heatId);
                }}
                onBlur={() => {}}
                showNext={!!heat.NextHeatId}
                showPrevious={!!heat.PreviousHeatId}
                onNext={(heatId) => {
                  getDataFromAPI(heatId);
                }}
                onPrevious={(heatId) => {
                  getDataFromAPI(heatId);
                }}
                onLast={() => {
                  getDataFromAPI(null);
                }}
              />
            </Grid>
          </Grid>
          {/* Column 2 */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            container
            spacing={1}
            key="col-main-data-1"
          >
            <Grid
              item
              xs={12}
              container
              direction="row"
              spacing={1}
              alignContent="flex-start"
            >
              <Grid item xs={12} key="tap-time">
                <TextField
                  label="Tap Time"
                  value={
                    heat.TapDate
                      ? `${moment(heat.TapDate).format("HH:mm - MM/DD/YYYY ")} - Shift ${heat.TapShift} - Crew ${heat.TapCrew}`
                      : ""
                  }
                  variant="outlined"
                  fullWidth
                  onChange={() => {}}
                />
              </Grid>
              <Grid item xs={12} key="open-time">
                <TextField
                  label="Open"
                  value={
                    heat.OpenDate
                      ? `${moment(heat.OpenDate).format("HH:mm - MM/DD/YYYY")} - Shift ${heat.OpenShift} - Crew ${heat.OpenCrew}`
                      : ""
                  }
                  variant="outlined"
                  fullWidth
                  onChange={() => {}}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Column 3 */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            container
            spacing={1}
            key="col-main-data-2"
          >
            <Grid
              item
              xs={12}
              container
              direction="row"
              spacing={1}
              alignContent="flex-start"
            >
              <Grid item xs={6} key="ladle">
                <LeftGroupedTextField
                  label="Ladle"
                  variant="outlined"
                  size="small"
                  value={heat.LadleName || ""}
                />
              </Grid>
              <Grid item xs={6} key="ladle-life">
                <RightGroupedTextField
                  label="Ladle Life"
                  variant="outlined"
                  size="small"
                  value={heat.HeatsOnLadle || ""}
                />
              </Grid>

              <Grid item xs={12} key="grade">
                <TextField
                  label="Grade"
                  value={heat.Grade ?? ""}
                  variant="outlined"
                  fullWidth
                  onChange={() => {}}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Column 4 */}
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            container
            spacing={1}
            key="col-main-data-3"
          >
            <Grid
              item
              xs={12}
              container
              direction="row"
              spacing={1}
              alignContent="flex-start"
            >
              <Grid item xs={12} key="final-status">
                <TextField
                  label="Final Status"
                  value={getHeatStatus(heat.FinalStatus ?? "").name}
                  variant="outlined"
                  fullWidth
                  onChange={() => {}}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="start">
                          <div
                            style={{
                              width: "26px",
                              height: "26px",
                              borderRadius: 4,
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: theme.palette.common.white,
                              fontWeight: "bold",
                              backgroundColor: heat.FinalStatus
                                ? getHeatStatus(heat.FinalStatus).color
                                : theme.palette.grey[400],
                            }}
                          >
                            {heat.FinalStatus}
                          </div>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};
